import { z } from "zod/v4";

export const BrowserlessCookieSchema = z.object({
  name: z.string(),
  value: z.string(),
  domain: z.string(),
  path: z.string(),
});

export type BrowserlessCookie = z.infer<typeof BrowserlessCookieSchema>;
